var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed right-4 bottom-4 w-80 z-50"},_vm._l((_vm.messages),function(message){return _c('div',{key:message.id,staticClass:"p-4 border-l-8 rounded mt-4 flex",class:{
      'border-red-600 text-red-600 bg-red-100':
        message.type === 'danger' || message.type === 'error',
      'border-green-700 text-green-700 bg-green-100':
        message.type === 'success'
    }},[_c('icon',{attrs:{"face":"mdiAlert"}}),_c('span',{staticClass:"text-xs pl-2"},[_vm._v(_vm._s(_vm.$t(message.body, message.args)))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }